export function VerifiedBadgeIcon() {
  return (
    <svg
      className="w-6 h-6 text-gray-800"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 1l2.753 3.978 4.8-1.259-1.26 4.8L22 12l-3.707 3.481 1.26 4.8-4.8-1.26L12 23l-2.753-3.979-4.8 1.26 1.26-4.8L2 12l3.707-3.481-1.26-4.8 4.8 1.26L12 1z" />
      <path
        d="M9 12l2 2 4-4"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export function SmallCheckIcon() {
  return (
    <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path
        d="M2.5 6l2.5 2.5 4.5-5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function XIcon() {
  return (
    <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path
        d="M2 2l8 8M10 2l-8 8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function FailedBadgeIcon() {
  return (
    <svg
      className="w-6 h-6 text-red-700"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 1l2.753 3.978 4.8-1.259-1.26 4.8L22 12l-3.707 3.481 1.26 4.8-4.8-1.26L12 23l-2.753-3.979-4.8 1.26 1.26-4.8L2 12l3.707-3.481-1.26-4.8 4.8 1.26L12 1z" />
      <path
        d="M9 9l6 6M15 9l-6 6"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
